<template>
  <div>
    <div v-for="i in 2" :key="i" class="mb-4">
      <div class="row">
        <div class="col-4 mb-2">
          <b-skeleton height="25px"></b-skeleton>
        </div>
      </div>
      <div class="row mb-2" v-for="i in 10" :key="i">
          <div class="col-2 pr-0">
            <b-skeleton height="20px"></b-skeleton>
          </div>
          <div class="col-6">
            <b-skeleton height="20px"></b-skeleton>
          </div>
          <div class="col-2 offset-2">
            <b-skeleton height="20px"></b-skeleton>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FiltersSkeleton",
};
</script>
